import { render, staticRenderFns } from "./AnimatedSprite.vue?vue&type=template&id=014b325e&scoped=true&"
import script from "./AnimatedSprite.vue?vue&type=script&lang=ts&"
export * from "./AnimatedSprite.vue?vue&type=script&lang=ts&"
import style0 from "./AnimatedSprite.vue?vue&type=style&index=0&id=014b325e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.9.8_m6jvttnwtqqy6l4pi5vsxiehsy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014b325e",
  null
  
)

export default component.exports